/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { BadgeType } from '@wit/vtv-x-foundation-lib';

/**
 * rail: [[],[],[]]
 * index 0: priorities list (more priority to less) for slot1
 * index 1: priorities for slot2
 * index 2: priorities for slot3
 */
interface RailBadgesPriority {
  [rail: string]: Array<BadgeType[]>;
}

interface BadgesPriority {
  [section: string]: RailBadgesPriority;
}

const BADGES_PRIORITY_PER_SECTION_RAIL: BadgesPriority = {
  MY_TV: {
    WATCH_NEXT_RAIL: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
    RECOMMENDATION_RAIL: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
    RECORDING_RAIL: [
      [BadgeType.EXPIRY_CLOCK],
      [
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
      ],
      [BadgeType.LOCK],
    ],
    SCHEDULE_RECORDING: [[BadgeType.LOCK], [], []],
    RENTAR_AND_PURCHASES_RAIL: [[BadgeType.EXPIRY_CLOCK], [BadgeType.LOCK], []],
    SUBSCRIPTION_RAIL: [[BadgeType.LOCK], [], []],
    WISHLIST_RAIL: [
      [BadgeType.EXPIRY_CLOCK],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.PURCHASE,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
  },
  WATCH_TV: {
    ON_NOW: [
      [],
      [BadgeType.RESTART],
      [
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.RECORDABLE,
      ],
    ],
    FUTURE_AND_PAST: [
      [],
      [BadgeType.PLAY],
      [
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.RECORDABLE,
      ],
    ],
  },
  SEARCH: {
    ALL_RESULTS_RAIL: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.PURCHASE,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
  },
  ONDEMAND: {
    RAILS: [[BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON], [BadgeType.PLAY, BadgeType.PURCHASE], [BadgeType.LOCK]],
    RAILS_RECOMMENDATION: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [BadgeType.PLAY, BadgeType.PURCHASE],
      [BadgeType.LOCK],
    ],
  },
  ALL: {
    RELATED_RAILS: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.PURCHASE,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
    MORE_EPISODES_RAILS: [
      [BadgeType.EXPIRY_CLOCK, BadgeType.WISHLIST_ON],
      [
        BadgeType.PLAY,
        BadgeType.PROTECTED_RECORDING,
        BadgeType.LIVE_SERIES_RECORDING,
        BadgeType.LIVE_RECORDING,
        BadgeType.SERIES_SCHEDULED_RECORDING,
        BadgeType.SINGLE_SCHEDULED_RECORDING,
        BadgeType.SERIES_RECORDING,
        BadgeType.SINGLE_RECORDING,
        BadgeType.PURCHASE,
        BadgeType.AIRS_ON,
      ],
      [BadgeType.LOCK],
    ],
  },
};

export default BADGES_PRIORITY_PER_SECTION_RAIL;
